
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/[product]/search",
      function () {
        return require("private-next-pages/[company]/[product]/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/[product]/search"])
      });
    }
  